import React from 'react';
import WorkingHoursBlock from './WorkingHoursBlock';
import styled from '@emotion/styled';
import { Button } from 'react-bootstrap';
import getLangData from '../../../utils/getLangData';

const WorkingHours = props => {
  const { name, disabled, children } = props;

  return (
    <WorkingHoursContainer>
      <WorkingHoursHeader />
      {children}
      <WorkingHoursBlock
        disabled={disabled}
        name={name}
        label={getLangData().days.monday}
        day='monday'
      />{' '}
      <WorkingHoursBlock
        disabled={disabled}
        name={name}
        label={getLangData().days.tuesday}
        day='tuesday'
      />
      <WorkingHoursBlock
        disabled={disabled}
        name={name}
        label={getLangData().days.wednesday}
        day='wednesday'
      />
      <WorkingHoursBlock
        disabled={disabled}
        name={name}
        label={getLangData().days.thursday}
        day='thursday'
      />
      <WorkingHoursBlock
        disabled={disabled}
        name={name}
        label={getLangData().days.friday}
        day='friday'
      />
      <WorkingHoursBlock
        disabled={disabled}
        name={name}
        label={getLangData().days.saturday}
        day='saturday'
      />
      <WorkingHoursBlock
        disabled={disabled}
        name={name}
        label={getLangData().days.sunday}
        day='sunday'
      />
    </WorkingHoursContainer>
  );
};

const WorkingHoursContainer = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const WorkingHoursHeader = () => {
  return (
    <HeaderContainer>
      <div>{getLangData().fields.active}</div>
      <div>{getLangData().fields.from}</div>
      <div>{getLangData().fields.to}</div>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 13px;
  & > * {
    text-align: center;
    margin: 0 8px;
  }
  & div:nth-of-type(1) {
    width: 65px;
  }
  & div:nth-of-type(2) {
    width: 242px;
  }
  & div:nth-of-type(3) {
    width: 242px;
  }
`;

export default WorkingHours;
